import { NgModule } from '@angular/core';

import { LoggerModule } from '../logger/logger';
import { ClientSettingsService } from './service/client-settings.service';

@NgModule({
  imports: [LoggerModule],
  declarations: [],
  providers: [ClientSettingsService],
  exports: [],
})
export class ClientSettingsModule {}
